// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3bd7cd43] .el-table{overflow:visible!important}.tipColumn[data-v-3bd7cd43]{background-color:bisque;margin:0 10px 10px;height:39px;line-height:39px;font-size:16px;border-bottom:1px solid;border-top:1px solid}.tipColumn1[data-v-3bd7cd43]{margin-left:12px}div[data-v-3bd7cd43] .el-table__body-wrapper{max-height:348px!important}", ""]);
// Exports
module.exports = exports;
